import { get } from 'lodash/fp';
import toInventoryItemUniqKey from '../../toInventoryItemUniqKey';

export default function createOrderItemKey(orderItem) {
  const itemId = get('inventoryItemId', orderItem);
  const locationId = get('inventoryLocationId', orderItem);
  const zoneId = get('inventoryLocationZoneId', orderItem);

  return toInventoryItemUniqKey(itemId, locationId, zoneId);
}
